/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IPromoBannerViewProps } from './promo-banner';

const PromoBannerView: React.FC<IPromoBannerViewProps> = props => {
    const {
        promoBannerProps,
        contentProps,
        closeButton,
        bannerMessages,
        PromoBannerTextProps,
        PromoBannerLinksProps,
        CarouselProps,
        handleLinks,
        handleText
    } = props;

    const slides = bannerMessages && bannerMessages.map((message, index) => {
        return (
            <Node {...contentProps} key={index}>
                {message.text && <Node {...PromoBannerTextProps} text={message.text} onClick={handleText} />}
                {message.links && message.links.length > 0 && <Node {...PromoBannerLinksProps} links={message.links} onClick={handleLinks} />}
            </Node>
        );
    });

    return (
        <Module {...promoBannerProps}>
            <Node {...CarouselProps} items={slides} />
            {closeButton}
        </Module>
    );
};
export default PromoBannerView;
